import React, { useState } from "react";
import PropTypes from "prop-types";
import { AlertTriangle, Button } from "@opendate-app/setlist";
import client from "../../shared/api/client";
import { toastError, toastSuccess } from "../../shared/toastHelper";

const ToastLaborSyncBanners = ({ toastLaborSyncs }) => {
  const [syncs, setSyncs] = useState(toastLaborSyncs);
  const [savingId, setSavingId] = useState(null);

  const turnOff = async (sync) => {
    setSavingId(sync.id);
    try {
      await client.patch(sync.updatePath, { toast_access: { sync_labor_costs: false } });
      setSyncs((current) => current.filter((item) => item.id !== sync.id));
      toastSuccess(`Toast labor sync is off for ${sync.venueName}. New Toast labor won't be added to events.`);
    } catch (error) {
      toastError(`Could not turn off Toast labor sync for ${sync.venueName}.`);
    } finally {
      setSavingId(null);
    }
  };

  return syncs.map((sync) => (
    <div
      key={sync.id}
      className="d-flex flex-wrap align-items-center"
      style={{
        gap: 12,
        padding: "12px 16px",
        border: "1px solid var(--sl-border-warning)",
        background: "var(--sl-bg-warning-primary)",
        borderRadius: "var(--sl-radius-xl)",
        marginBottom: 16,
      }}
    >
      <AlertTriangle width={20} height={20} style={{ flexShrink: 0, color: "var(--sl-fg-warning)" }} />
      <div style={{ flex: "1 1 360px", fontSize: 14, lineHeight: "20px", color: "var(--sl-text-warning)" }}>
        <b style={{ fontWeight: 600 }}>Toast labor sync is also on.</b>{" "}
        {`Event settlements will show two Labor lines for ${sync.venueName}, one from Toast and one from Staffing.`}
      </div>
      <Button variant="secondary" disabled={savingId === sync.id} onClick={() => turnOff(sync)}>
        Turn off Toast labor sync
      </Button>
    </div>
  ));
};

ToastLaborSyncBanners.propTypes = {
  toastLaborSyncs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      venueName: PropTypes.string.isRequired,
      updatePath: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default ToastLaborSyncBanners;
